import styled from 'styled-components';
import { RenderViewValuesAlignmentParams } from '../../../../../common/renderer/component-types/types-render-view-values-alignment';
import { ValuesAlignmentTable } from '../../../../common/upright/model/output/scores/values-alignment-table';
import { useRenderViewContext } from '../../context';
import { toComparisonItem } from '../../utils';

export const RenderViewValuesAlignmentTable = () => {
  const context = useRenderViewContext();
  const renderItems = context.options.items;
  const data = context.data;

  const valueSetIds = (context.componentParams[0] as RenderViewValuesAlignmentParams).valueSetIds;

  if (!data || !renderItems) {
    return <></>;
  }

  const items = renderItems.map(i => toComparisonItem(i, data));

  return (
    <Root>
      <ValuesAlignmentTable {...{ items, valueSetIds }} />
    </Root>
  );
};

const Root = styled.div``;
